<template>
  <div style="width: 100%;">
    <div class="gallery-message message">
      <gallery-item
        v-for="(item, index) in galleryItems"
        :key="index"
        :item="item"
        :message="message"
      />
    </div>
  </div>
</template>

<script>
// @flow
import { ChatchampMessageItem } from '@chatchamp/chatchamp-types'

import GalleryItem from './GalleryItem/GalleryItem.vue'

export default {
  components: {
    GalleryItem
  },
  props: {
    message: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    galleryItems (): Array<ChatchampMessageItem> {
      return this.message.content.elements
    }
  }
}
</script>

<style src="./gallery-message.scss" />
